import { makeStyles, Theme } from '@material-ui/core/styles';
import Image from '../../assets/Patterns.png';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
    background: `url(${Image}), linear-gradient(180deg, #FFFFFF -30.28%, #E2E6F7 161.33%)`,
    backgroundPosition: 'bottom, left top',
    backgroundRepeat: 'repeat-x, repeat',
    backgroundSize: 'contain, cover',
    minHeight: 'calc(100vh - 106px)',
  },
  formContainer: {
    margin: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
    width: '500px',
    '@media (max-width: 768px)': {
      width: '80%',
    },
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    height: '106px',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #E0E0E0',
  },
  footer: {
    margin: '60px 0 30px 0',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '26px',
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.54)',
    '@media (max-width: 768px)': {
      position: 'relative',
      bottom: 0,
      right: 0,
      transform: 'none',
      margin: '60px 0 30px',
    },
  },
}));
